import { render, staticRenderFns } from "./ComponentspeakerDetails.vue?vue&type=template&id=23f1267b"
import script from "./ComponentspeakerDetails.vue?vue&type=script&lang=js"
export * from "./ComponentspeakerDetails.vue?vue&type=script&lang=js"
import style0 from "./ComponentspeakerDetails.vue?vue&type=style&index=0&id=23f1267b&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports